import { Navigate, useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import { motion } from "framer-motion";
import { notifyErrorCustom } from "../../../utils/notify";
import { useEffect, useState } from "react";
import { BrandingService, UserAccountsService } from "../../../services";
import { PreviousPass } from "../../../components/PreviousPass";
import { useTranslation } from "react-i18next";
import { InterrogationCircleIcon, LetterA, Pencil, PencilSquare, QuestionSquare } from "../../../assets/svgs/icons";
import { getBusinessByLogin } from "../../../services/business";
import { FooterNaviBar } from "../../../components/FooterNaviBar";

function StepBranding({setStep, colors }) {
  const STEPS = {
    STEP_PASS_COLOR_PALETTE: 'StepColorPalette',
    STEP_PASS_NICHE_AND_OBJECTIVE: 'stepNIcheAndObjective',
    STEP_PASS_LOGO: 'stepLogo',
    STEP_PASS_TYPOGRAPHY: 'stepTypography',
  };
  const [branding, setBranding] = useState()

  useEffect(() => {
    loadBranding()
  }, [])


  const handleNavigate = async (type) => {
    if (type === "color") {

      setStep(STEPS.STEP_PASS_COLOR_PALETTE);
    } 
    if (type === "tipografia") {
     
      setStep(STEPS.STEP_PASS_TYPOGRAPHY);
    }

    if (type === 'next') {
      if (colors.length < 3) {
        notifyErrorCustom(t('fast_publishing_choose_at_least_3_colors'))
        return
      }

      const responseBusines = await getBusinessByLogin()

      const hasEmptyField = colors.some((item) => !item)

      if (hasEmptyField) {
        notifyErrorCustom(t('fast_publishing_one_field_is_empty'))
        return
      }

      let colorsArray = {
        //businessId: responseBusines?.data[0]?.uuid,
        primaryColor: colors[0],
        secondaryColor: colors[1],
        tertiaryColor: colors[2] ?? '',
        complementaryColor1: colors[3] ?? '',
        complementaryColor2: colors[4] ?? '',

        fontTitleId: '',
        //fontTitleByUploaded: '',

        fontSubtitleId: '',
        //fontSubtitleByUploaded:'',

        fontTextId: '',
        //fontTextByUploaded: '',

        fontTitleByUploaded: false,
        fontSubtitleByUploaded: false,
        fontTextByUploaded: false,
      }

      if (branding) {
        colorsArray = {
          primaryColor: colors[0],
          secondaryColor: colors[1],
          tertiaryColor: colors[2] ?? '',
          complementaryColor1: colors[3] ?? '',
          complementaryColor2: colors[4] ?? '',
          fontTitleId: branding.fontTitleId,
          //fontTitleByUploaded,

          fontSubtitleId: branding.fontSubtitleId,
          //fontSubtitleByUploaded:'',

          fontTextId: branding.fontTextId,
          //fontTextByUploaded,

          fontTitleByUploaded: branding.fontTitleByUploaded,
          fontSubtitleByUploaded: branding.fontSubtitleByUploaded,
          fontTextByUploaded: branding.fontTextByUploaded,
        }

        const { responseStatus } = await BrandingService.putBranding(
          branding.uuid,
          colorsArray
        )
        //return
      } else {
        await BrandingService.postBranding(colorsArray)
      }

      setStep(STEPS.STEP_PASS_LOGO)
    } 

    if(type === 'back') {
      setStep(STEPS.STEP_PASS_NICHE_AND_OBJECTIVE)
    }
  };

  const loadBranding = async () => {
    const { data } = await BrandingService.getAllBrandingByBusinessId(
      businessAccountData.data.uuid
    )
    setBranding(data[0])
  }

  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ x: "100vw" }}
      animate={{ x: 0 }}
      exit={{ x: "-100vw" }}
      transition={{ type: "tween", duration: 0.5 }}
      style={{
        width: "100%",
        height: '100%',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className={styles.box_step}>
        <div className={styles.box_title}>
          <div  className={styles.box_title_text}>
            <h1>{t('fast_publishing_branding_title')}</h1>
            <InterrogationCircleIcon/>
          </div>
          <p>{t('fast_publishing_branding_subtitle')}</p>
        </div>

        <div className={styles.box_content}>
          <div className={styles.box_option_step} onClick={() => handleNavigate('color')}>
            <Pencil size="30" color={'#6A0098'}/>
            {t('fast_publishing_colors')}
          </div>

          <div className={styles.box_option_step} onClick={() => handleNavigate('tipografia')}>
            <LetterA color="#6A0098" size="30"/>
            {t('fast_publishing_tipografy')}
          </div>
        </div>


        <div className={styles.container_suggestion}>
          <div className={styles.box_icon_suggestion}>
            <QuestionSquare/>
          </div>
          <div className={styles.box_suggestion}>
            <p style={{fontFamily: 'Poppins', 
              fontWeight: '300',
              fontSize: '14px',
              lineHeight: '100%',
              letterSpacing: '0%',}
            }>{t('fast_publishing_suggestion')}</p>
            <p style={{fontFamily: 'Poppins',
              fontWight: '400',
              fontSize: '18px',
              lineHeight: '100%',
              letterSpacing: '0%'}
            }>{t('fast_publishing_suggestion1')} <strong style={{color: '#190027'}}>{t('fast_publishing_suggestion2')} </strong> {t('fast_publishing_suggestion3')}</p>
          </div>
        </div>
        <FooterNaviBar
          back={() => handleNavigate('back')}
          next={() => handleNavigate('next')}
        />
      </div>
    </motion.div>
  );
}

export default StepBranding;
